<template lang="pug">
v-dialog(
  scrollable lazy
  :persistent='isModified'
  :fullscreen='isFullscreen'
  :transition='transition'
  v-model='dialog'
  :max-width='1000'
)
  v-card(@keyup.esc='close')
    //- 對話框標題列

    v-toolbar(color='primary' dark style={zIndex: 10000})
      v-btn(icon dark @click='close' :disabled='isLoading'): v-icon close
      v-toolbar-title 編輯報名表單 #[ModifiedDot(:show='isModified && !isLoading')]
      v-spacer
      v-toolbar-items: v-btn(flat @click='save' v-if='!isRetired' :loading='isLoading') {{ $t('saveAndPublish') }}
      v-menu(bottom right offset-y max-width='300' :disabled='isLoading' v-if='!isRetired')
        v-btn(slot='activator' icon): v-icon more_vert
        v-list
          v-list-tile(@click='setManualBill' v-if='isManualBillShow')
            v-list-tile-action: v-icon fas fa-money-check-alt
            v-list-tile-title 手動設為已繳費
          v-list-tile(@click='advance' :disabled='isAdvanceDisabled')
            v-list-tile-action: v-icon fas fa-level-up-alt
            v-list-tile-title 晉級表單

          v-divider
          v-list-tile(@click='remove' :disabled='isRemoveDisabled' :title='isRemoveDisabled ? `無法移除此表單，因為此表單狀態為「已繳費」` : ``')
            v-list-tile-action: v-icon(:color='isRemoveDisabled ? `` : `error`') fas fa-trash-alt
            v-list-tile-title(:class='isRemoveDisabled ? `` : `error--text`') 移除此報名表單

    //- 錯誤提示訊息
    v-alert(type='error' :value='true' v-if='form === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

    //- 行動版用的底部導覽列
    v-bottom-nav(
      class='bottom-nav'
      :value='form && isMobile'
      :active.sync='selectedTab' fixed
    )
      v-btn(color='primary' flat :value='i.id' v-for='(i, index) in tabItems' :key='index')
        span {{ i.name }}
        v-icon(small) {{ i.icon }}

    //- 表單
    v-card-text(v-if='form')
      v-alert.mb-3(:value='isRetired' type='info' color='grey') 表單為唯獨狀態，因為報名者已申請退賽
      v-form(v-model='valid' :style='formStyle')
        v-container.pa-0
          v-layout(row wrap)
            v-flex(xs12 md6 v-if='selectedTab === 0 || !isMobile')
              //- 唯獨欄位(報名人資料)
              //-    a. 內容以禁用的文字框顯示(暫時棄用)
              template(v-if='isUserInfoTextFieldStyle')
                v-text-field(v-for='i in memberItems' :key='i.key' :label='i.name' :value='form[i.key]' v-if='form[i.key]' disabled)
              //-    b. 內容以 flex 區塊顯示
              v-layout(row wrap v-else)
                v-flex(v-for='i in memberItems' :key='i.key' v-if='form[i.key]')
                  .mr-3.mb-3
                    .caption.grey--text {{ i.name }}
                    .subheading: CopyableText
                      PhoneNumberText(v-if='i.key === `phone`' :value='form[i.key]')
                      span(v-else) {{ form[i.key] }}

              v-select(label='組別' :items='groupList' :value='form.group' disabled)
              v-text-field(label='歌曲' v-model='form.song' required)
              v-combobox(v-model='form.partners' label='團員' hint='學校 / 姓名 / 負責樂器' multiple chips)
                template(slot='selection' slot-scope='data')
                  v-chip.v-chip--select-multi(
                    :selected='data.selected'
                    :disabled='data.disabled'
                    :key='JSON.stringify(data.item)'
                    @input='data.parent.selectItem(data.item)'
                    close
                  )
                    v-avatar.primary--text: v-icon account_circle
                    | {{ data.item }}

              v-radio-group(label='繳費狀態: ' v-model.number='form.status' row v-if='isStatusShow')
                v-radio(v-for='i in formStatusList' color='primary' :label='i.text' :value='i.value' :key='i.value')
              v-text-field(label='繳費代碼' v-model='form.code' v-if='!isThisFromECPay')
              PaymentCard(v-else :payment='payment' :isManualBill='form.isManualBill')
              v-layout.mt-3(row wrap)
                //- TODO: 包裝成組件
                v-flex(shrink)
                  .mb-3.mr-3
                    .caption.grey--text 報名人銀行代碼
                    .subheading: CopyableText
                      span {{ form.memberBankCode || `-` }}
                v-flex(shrink)
                  .mb-3
                    .caption.grey--text 報名人銀行帳號
                    .subheading: CopyableText
                      span {{ form.memberAccount || `-` }}

            v-flex(xs12 md6 v-if='selectedTab === 1 || !isMobile')
              v-subheader.pl-0 設備數量
              v-layout(row wrap)
                v-flex(
                  xs6 sm4 md3
                  v-for='(name, key) in equipmentTable'
                  v-if='!(key === `effector` || key === `other`)'
                  :key='key'
                )
                  NumberPicker.mb-2(v-model.number='form.equipment[key]' :max='getEquipmentMax(key)' :label='convertEquipmentText(key)')
              v-text-field(label='效果器' v-model='form.equipment.effector' hint='效果器型號')
              v-textarea(label='備註' v-model='form.equipment.other' rows='3' hint='其他設備需求 (如: 手鈸)')

            //- 自定義欄位
            v-flex(xs12)
              v-divider.my-0(v-if='!isMobile')
              v-subheader.pl-0 自定義欄位
              template(v-for='type in [`commonField`, `customField`]')
                .mb-2(v-for='(i, index) in form[type]' :key='type + index')
                  .caption.grey--text {{ i.label }} {{ i.isRequired ? `*` : `` }}
                  .subheading.wrap {{ i.value || `-` }}

      DebugCodeBlock(:value='form')

    Loader(:show='form === null')
</template>

<script>
import apis from '@/assets/js/apis'
import { formStatus } from '@/mixins/formStatus'
import NumberPicker from '@/components/NumberPicker.vue'
import PaymentCard from '@/components/form/PaymentCard.vue'
import CopyableText from '@/components/CopyableText.vue'
import PhoneNumberText from '@/components/PhoneNumberText.vue'

export default {
  name: 'EditForm',
  data () {
    this.isUserInfoTextFieldStyle = false
    return {
      valid: false,
      form: null,
      id: null,
      memberItems: [
        { name: '報名人', key: 'name' },
        { name: '報名人學校', key: 'school' },
        { name: 'Email', key: 'email' },
        { name: '電話', key: 'phone' },
        // { name: `組別`, key: `group` }
      ],
      selectedTab: 0,
      tabItems: [
        { id: 0, name: '報名資料', icon: 'fas fa-user' },
        { id: 1, name: '設備', icon: 'fas fa-guitar' },
        { id: 2, name: '自定義欄位', icon: 'fas fa-pen' },
      ],
    }
  },
  props: {
    period: {
      type: Number,
      default: null,
    },
  },
  methods: {
    show (id) {
      this.clearError()
      this.dialog = true
      this.id = id
      this.fetch()
    },
    async fetch () {
      const params = { formId: this.id, period: this.period }
      this.form = null
      this.isModified = true
      try {
        this.form = await apis.form.get(params, this.token)
        this.$nextTick(() => { this.isModified = false })
      } catch (e) {
        this.error = e
      }
    },
    async save () {
      if (!this.valid) return
      this.isSaving = true
      const body = { ...this.form, formId: this.id, period: this.period }
      this.clearError()

      try {
        await apis.form.put(body, this.token)
        this.$emit('success')
        this.close()
      } catch (e) {
        this.error = e
        this.isSaveFailed = true
        this.isSaving = false
      }
    },
    remove () {
      if (!confirm('是否確認移除此報名表單？')) return
      if (this.isRemoveDisabled) {
        alert('無法移除此表單，因為此表單狀態為「已繳費」')
        return
      }

      this.clearError()
      this.isSaving = true
      const body = { id: this.id, period: this.period }

      apis.form.remove(body, this.token)
        .then(() => {
          this.$emit('success', 'remove')
          this.close()
        })
        .catch((e) => {
          this.isSaveFailed = true
          this.error = e
          this.isSaving = false
        })
    },
    getEquipmentMax (index) {
      const school = this.$store.state.userInfo
      const groupId = this.form.group
      try {
        return school ? school.groupConfig[groupId][index] ? school.groupConfig[groupId][index].max : 10 : 10
      } catch (e) {
        return 10
      }
    },
    close () {
      this.dialog = false
      this.isSaving = false
      this.isModified = false
    },
    advance () {
      if (this.isModified) {
        alert('有尚未發佈的變更！請先發佈或者捨棄變更再執行此操作')
        return
      }
      if (!confirm('是否確認晉級此表單？')) return

      this.clearError()
      this.isSaving = true
      const body = { formId: this.id, period: this.period }

      apis.form.advance(body, this.token)
        .then(() => {
          this.$emit('success', 'advance')
          this.close()
        })
        .catch((e) => {
          const status = e.response.status
          if (status >= 400 && status < 500) { alert('操作失敗！ 可能已晉級過此表單，請重新確認') } else { alert('操作失敗！ 請確認網路連線是否正常，若仍出現錯誤請聯繫客服人員') }
          this.isSaving = false
        })
    },
    setManualBill () {
      if (this.isModified) {
        alert('有尚未發佈的變更！請先發佈或者捨棄變更再執行此操作')
        return
      }
      if (!confirm('是否確認手動設定該表單狀態為「已繳費」？此動作將無法撤銷\n\n此功能用於現場繳費等情境，設定後此筆表單金額將會設為 $0 且不會列入帳務中。')) return

      this.clearError()
      this.isSaving = true
      const body = { formId: this.id, period: this.period }
      apis.form.manualBill(body, this.token)
        .then(() => {
          this.$emit('success', 'manualBill')
          this.close()
        })
        .catch((e) => {
          const status = e.response.status
          if (status >= 400 && status < 500) { alert('操作失敗！ 請重新確認') } else { alert('操作失敗！ 請確認網路連線是否正常，若仍出現錯誤請聯繫客服人員') }
          this.isSaving = false
        })
    },
  },
  computed: {
    isLoading () {
      return (this.isSaving || !this.form) && !this.error
    },
    formStatusList () {
      const list = []
      for (const key in this.formStatusTable) {
        if (+key !== 3) {
          list.push({ text: this.formStatusTable[key].name, value: +key })
        }
      }
      list.sort((a, b) => b.value - a.value)
      return list
    },
    groupList () {
      const groupConfig = this.$store.state.userInfo ? this.$store.state.userInfo.groupConfig : null

      if (groupConfig) {
        const list = []
        for (const key in groupConfig) {
          list.push({ value: +key, text: this.convertGroupText(+key) })
        }
        return list.sort((a, b) => a - b)
      }
      return this.$store.state.userInfo.group.map(value => {
        return { value, text: this.convertGroupText(value) }
      })
    },
    level () {
      return this.form ? this.form.level : null
    },
    // 是否禁用晉級按鈕
    isAdvanceDisabled () {
      return this.form ? !this.form.isAdvanceable : true
    },
    isThisFromECPay () {
      return this.form && ('payment' in this.form)
    },
    // 是否顯示設定狀態按鈕
    isStatusShow () {
      return !this.isThisFromECPay && !this.isRetired
    },
    // 是否顯示手動設定已繳費按鈕
    isManualBillShow () {
      if (!this.form) return false
      const payment = this.form.payment

      // 若此表單使用金流服務 且 非(尚未)手動設定為已付款
      if (this.isThisFromECPay && !this.form.isManualBill) {
        // 若 payment 中有 rtnCode 這個 key，回傳 payment 的狀態是否非為已繳費
        if (payment !== null && 'rtnCode' in payment) return +payment.rtnCode !== 1
        return true
      }
      return false
    },
    isRetired () {
      return this.form && this.form.status === 3
    },
    payment () {
      return this.form ? this.form.payment : {}
    },
    formStyle () {
      return this.isMobile ? { marginBottom: '5rem' } : {}
    },
    isPaid () {
      if (!this.form) return
      const _ = this.form.payment
      return (_ && _.rtnCode && +_.rtnCode === 1)
    },
    isRemoveDisabled () {
      return this.isPaid
    },
    isCustomFieldBlockShow () {
      if (!this.form) return false

      const form = this.form
      const list = [form.customField, form.commonField]

      return list.some(_ => Array.isArray(_) && _.length > 0) &&
              (this.selectedTab === 2 || !this.isMobile)
    },
  },
  watch: {
    error (self) {
      if (self) {
        this.form = false
        this.isSaving = false
      }
    },
    form: {
      handler () {
        this.isModified = true
      },
      deep: true,
    },
  },
  mixins: [formStatus],
  components: {
    CopyableText,
    PhoneNumberText,
    NumberPicker,
    PaymentCard,
  },
}
</script>

<style scoped lang="sass">
.wrap
  white-space: pre-wrap

.bottom-nav
  height: auto !important
  padding-top: 4px
  padding-bottom: max(4px,env(safe-area-inset-bottom)) !important
</style>
